import { render, staticRenderFns } from "./BadgesEstado.vue?vue&type=template&id=70bf85eb"
import script from "./BadgesEstado.vue?vue&type=script&lang=js"
export * from "./BadgesEstado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports